if (process.env.GATSBY_STAGE !== 'production') {
  const ROUTES = {
    SURVEY_TOP_LEVEL: '/heliguy-survey',
    TRAINING_TOP_LEVEL: '/drone-training',
    INDUSTRY_TOP_LEVEL: '/industry',
    RENTAL: '/drone-hire',
    REPAIRS: '/dji-drone-repair-centre',
    DRONES: '/dji-drones-shop',
    PRODUCTS: '/products',
    EVENTS: '/events',
    POSTS: '/blogs/posts',
    SUPPORT: '/support',
    SERVICES: '/services',
    BLOG: '/blogs',
    CAREERS: '/careers',
    KNOWLEDGE_BASE: '/blogs/knowledge-base',
    SUPPORT_GUIDES: '/blogs/support-guides',
    BLACK_FRIDAY: '/black-friday',
    DATA_SECURITY: '/data-security',
    FILES_STORAGE: '/files-storage',
    FOLLOW_ME_PAGE: '/follow-me',
    UTILITIES_PAGE: '/utilities',
  }

  const PARENT_PAGE_MAP = {
    TRAINING: 'Training',
    RENTAL: 'Rental',
    REPAIRS: 'Repair',
    SURVEY: 'Survey',
    DRONES: 'Drones',
    None: 'None',
  }

  const SUB_PAGE_MAP = {
    [PARENT_PAGE_MAP.TRAINING]: ROUTES.TRAINING_TOP_LEVEL,
    [PARENT_PAGE_MAP.RENTAL]: ROUTES.RENTAL,
    [PARENT_PAGE_MAP.REPAIRS]: ROUTES.REPAIRS,
    // [PARENT_PAGE_MAP.SURVEY]: ROUTES.SURVEY_TOP_LEVEL,
    [PARENT_PAGE_MAP.DRONES]: ROUTES.DRONES,
    [PARENT_PAGE_MAP.None]: '',
  }

  module.exports = {SUB_PAGE_MAP, PARENT_PAGE_MAP, ROUTES}
} else {
  const ROUTES = {
    SURVEY_TOP_LEVEL: '/heliguy-survey',
    TRAINING_TOP_LEVEL: '/drone-training',
    INDUSTRY_TOP_LEVEL: '/industry',
    RENTAL: '/drone-hire',
    REPAIRS: '/dji-drone-repair-centre',
    DRONES: '/dji-drones-shop',
    PRODUCTS: '/products',
    EVENTS: '/events',
    POSTS: '/blogs/posts',
    SUPPORT: '/support',
    SERVICES: '/services',
    BLOG: '/blogs',
    CAREERS: '/careers',
    KNOWLEDGE_BASE: '/blogs/knowledge-base',
    SUPPORT_GUIDES: '/blogs/support-guides',
    BLACK_FRIDAY: '/black-friday',
    DATA_SECURITY: '/data-security',
    FILES_STORAGE: '/files-storage',
    FOLLOW_ME_PAGE: '/follow-me',
    UTILITIES_PAGE: '/utilities',
  }

  const PARENT_PAGE_MAP = {
    TRAINING: 'Training',
    RENTAL: 'Rental',
    REPAIRS: 'Repair',
    SURVEY: 'Survey',
    DRONES: 'Drones',
    None: 'None',
  }

  const SUB_PAGE_MAP = {
    [PARENT_PAGE_MAP.TRAINING]: ROUTES.TRAINING_TOP_LEVEL,
    [PARENT_PAGE_MAP.RENTAL]: ROUTES.RENTAL,
    [PARENT_PAGE_MAP.REPAIRS]: ROUTES.REPAIRS,
    [PARENT_PAGE_MAP.SURVEY]: ROUTES.SURVEY_TOP_LEVEL,
    [PARENT_PAGE_MAP.DRONES]: ROUTES.DRONES,
    [PARENT_PAGE_MAP.None]: '',
  }

  module.exports = {SUB_PAGE_MAP, PARENT_PAGE_MAP, ROUTES}
}
